class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return

    // Optional chaining doesn't protect the `in` operator: if sections is
    // missing, `'x' in undefined` throws rather than returning false.
    if (!state.sections?.['push-cart-count']) return

    const count = this.getCount(state.sections['push-cart-count'])

    this.textContent = count

    this.setAttribute('aria-hidden', count === 0)
    this.externalEls.urgency?.element?.setAttribute('aria-hidden', count === 0)
    this.externalEls['push-cart-footer']?.element?.setAttribute(
      'aria-hidden',
      count === 0,
    )
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return Number(DOM.querySelector('#push-cart-count')?.textContent ?? 0)
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
